import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    selector: 'ngx-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false
})
export class NgxIcon {

    @Input() type = 'material-icons';

    @Input() color = 'inherit';

    @Input() name: string | null;
    @Input() image: string | null;

}
